import { notification, Row, Col } from 'antd';

import update from 'immutability-helper';
import React from 'react';
import { connect } from 'react-redux';
import {
  addToTempCart,
  onQuantityChange,
  removeFromCart
} from '../../store/actions/cart.actions';
import { addToFavorite } from '../../store/actions/customer.actions';
import { getGalleryPhoto, transformProduct } from '../../utils/utils';
import ProductDesktop from './components/Desktop/ProductDesktop';
import './index.less';

class ProductPage extends React.Component {
  state = {
    activeGalleryPhoto: '',
    incompleteVariant: true,
    licenseChange: false,
    noStock: false,
    originalProduct: this.props.product,
    product: this.props.product,
    quantity: 1,
    quantityVariant: 1,
    reviewModal: false,
    selectedVariants: '',
    variant: ''
  };

  addProductToCart = (product) => {
    const { variant } = { ...this.state };
    if (variant) {
      if (variant?.images?.length === 0) {
        variant.images = product.images;
        variant.parent = variant.product_id;
      }
      const { reduxProducts, t, addToCart } = this.props;
      const index = reduxProducts.findIndex((item) => variant._id === item._id);
      // let quantity = 0;
      let { quantity } = this.state;
      if (index > -1) {
        quantity += reduxProducts[index].quantity;
      }

      if (
        quantity > variant?.stock /* - 1 */ &&
        (variant?.stock !== null || variant?.inventoryTracking !== 'no')
      ) {
        return notification.error({
          message: t('outOfStock'),
          className: 'custom-notification'
        });
      }

      addToCart(transformProduct(variant), /* 1, */ quantity);
      return notification.success({
        message: t('productAddedToCart'),
        className: 'custom-notification'
      });
    } else {
      const { reduxProducts, t, addToCart } = this.props;
      const index = reduxProducts.findIndex((item) => product._id === item._id);
      // let quantity = 0;
      let { quantity } = this.state;
      if (index > -1) {
        quantity += reduxProducts[index].quantity;
      }

      if (
        quantity > product.stock /* - 1 */ &&
        (product.stock !== null || product?.inventoryTracking !== 'no')
      ) {
        return notification.error({
          message: t('outOfStock'),
          className: 'custom-notification'
        });
      }

      addToCart(transformProduct(product), /* 1, */ quantity);
      return notification.success({
        message: t('productAddedToCart'),
        className: 'custom-notification'
      });
    }
  };

  addProductToFavorites = ({ _id }) => {
    const { addToFavorites } = this.props;
    addToFavorites(_id);
  };

  onQuantityChange = (val, product) => {
    if (product.stock === 0) return;
    const { value } = val.target;
    let newValue = value;
    // eslint-disable-next-line
    if (value == 0 || !value) newValue = 1;
    if (value < 0) return;
    if (
      value > product.stock &&
      (product.stock !== null || product.inventoryTracking !== 'no')
    )
      newValue = product.stock;
    this.setState({ quantity: +newValue });
    this.props.onQuantityChange(newValue, product);
  };

  decrementQuantity = (product) => {
    // let { quantity } = { ...this.state };
    // if (quantity === 1) {
    //   quantity = 1;
    // } else {
    //   quantity -= 1;
    // }
    // if (quantity > product.stock) quantity = product.stock;
    // this.setState({ quantity });
    // this.props.onQuantityChange(quantity, product);
    if (product.stock === 0) return;
    let { quantity } = { ...this.state };

    if (product.stock === null || product.inventoryTracking === 'no') {
      if (quantity < 2) {
        quantity = 1;
      } else {
        quantity -= 1;
      }
      this.setState({ quantity });
      this.props.onQuantityChange(quantity, product);
    } else {
      if (quantity < 2) {
        quantity = 1;
      } else {
        quantity -= 1;
      }
      //  if (quantity > product.stock) quantity = product.stock;
      this.setState({ quantity });
      this.props.onQuantityChange(quantity, product);
    }
  };

  incrementQuantity = (product) => {
    // let { quantity } = { ...this.state };
    // if (quantity > product.stock) quantity = product.stock;
    // this.setState({ quantity: quantity + 1 });
    // this.props.onQuantityChange(quantity + 1, product);
    console.log(product, '---PROOOODUCT');
    const { variant, quantity } = { ...this.state };
    if (variant) {
      if (variant.stock === 0) return;

      if (variant.stock === null || variant.inventoryTracking === 'no') {
        this.setState({ quantity: quantity + 1 });
        this.props.onQuantityChange(quantity + 1, product);
      } else {
        //  if (quantity > product.stock) quantity = product.stock;

        // if (quantity > product.orderQuantity.max) {
        //   quantity = product.orderQuantity.max;
        //   return notification.error({
        //     message: t('exceededOrderQuantity'),
        //     className: 'custom-notification'
        //   });
        // }
        // eslint-disable-next-line no-lonely-if
        if (quantity >= variant.stock) {
          this.setState({ quantity: variant.stock });
        } else {
          //  quantity = product.stock;
          this.setState({ quantity: quantity + 1 });
          this.props.onQuantityChange(quantity + 1, product);
        }
      }
    } else {
      if (product.stock === 0) return;

      if (product.stock === null || product.inventoryTracking === 'no') {
        this.setState({ quantity: quantity + 1 });
        this.props.onQuantityChange(quantity + 1, product);
      } else {
        //  if (quantity > product.stock) quantity = product.stock;

        // if (quantity > product.orderQuantity.max) {
        //   quantity = product.orderQuantity.max;
        //   return notification.error({
        //     message: t('exceededOrderQuantity'),
        //     className: 'custom-notification'
        //   });
        // }
        // eslint-disable-next-line no-lonely-if
        if (quantity >= product.stock) {
          this.setState({ quantity: product.stock });
        } else {
          //  quantity = product.stock;
          this.setState({ quantity: quantity + 1 });
          this.props.onQuantityChange(quantity + 1, product);
        }
      }
    }
  };

  setVariant = (values) => {
    const { product } = this.state;
    const parentProduct = { ...product };
    // eslint-disable-next-line no-unused-vars
    const modifiedValues = Object.entries(values).map(([k, v]) => v);

    const findVariant = parentProduct.variants
      .filter(({ options }) =>
        options.every(({ value: { _id } }) => modifiedValues.includes(_id))
      )
      .map(({ _id }) => _id);

    const variantId = findVariant[0];

    const variantIndex = parentProduct.variants.findIndex(
      (item) => variantId === item._id
    );

    const variant = parentProduct.variants[variantIndex];

    if (variant) {
      this.setState(
        update(this.state, {
          variant: { $set: variant },
          activeGalleryPhoto: {
            $set: getGalleryPhoto(variant, variant.layout, parentProduct)
          },
          product: {
            options: { $set: parentProduct.options }
          }
        })
      );
    } else {
      this.setState(
        update(this.state, {
          product: {
            options: { $set: parentProduct.options }
          },
          variant: { $set: '' },
          activeGalleryPhoto: {
            $set: getGalleryPhoto(parentProduct, parentProduct.layout, parentProduct)
          }
        })
      );
    }
  };

  render() {
    // console.log('SINGLE PRODUCT STATE', this.state.product);
    const { t, favorites, settings, customer, addToFavorites } = this.props;
    const { activeGalleryPhoto, product, quantity, variant } = this.state;

    return (
      <>
        <Row type="flex" justify="center" className="product-desktop-container">
          <Col span={24}>
            <ProductDesktop
              activeGalleryPhoto={activeGalleryPhoto}
              addProductToCart={this.addProductToCart}
              addProductToFavorites={this.addProductToFavorites}
              addToFavorites={addToFavorites}
              customer={customer}
              decrementQuantity={this.decrementQuantity}
              favorites={favorites}
              incrementQuantity={this.incrementQuantity}
              onQuantityChange={this.onQuantityChange}
              product={product}
              quantity={quantity}
              settings={settings}
              setVariant={this.setVariant}
              t={t}
              variant={variant}
            />
          </Col>
        </Row>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    customer: state.customer,
    products: state.cart.products,
    settings: state.settings.settings,
    favorites: state.customer.favorites,
    reduxProducts: state.cart.products
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    onQuantityChange: (value, product) => dispatch(onQuantityChange(value, product)),
    removeFromCart: (index) => dispatch(removeFromCart(index)),
    addToCart: (product, quantity /* , extraQuantity */) =>
      dispatch(addToTempCart(product, quantity /* , extraQuantity */)),
    addToFavorites: (favorite) => dispatch(addToFavorite(favorite))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductPage);
